import TFRClassification from './TFRClassification';

import './TFRClassification.scss';

export default TFRClassification;
